import BenefitDictionary from "utils/BenefitDictionary";

const benefitDictionary = new BenefitDictionary()

export const getRegularBenefitAdapt = (contextState, benefit) => {
  return {
    BeginDate: contextState.coverage,
    EndDate: "",
    Description: benefit["factorId.nameFactor"],
    PortalType: benefitDictionary.getBenefitValue(benefit["factorId.portalType"]), // ???
    CodeFactor: benefit["factorId.factorTypeId.codeFactor"],
    CodeOption: benefitDictionary.getOptionValue(benefit["factorId.portalType"], (benefit["codeFactorOption"] == 'deductbl_no' ? 0 : benefit["codeFactorOption"])),
    DescriptionOption: benefit["description"],
    IdBenefit: benefit["factorId.id"].toString(), // ???
    IdOption: benefit["id"].toString(),
    Factor: benefit["factor"],
    NoCoverage: benefit["isNoCoverageOption"] ? "1" : "0",
    status: "A", // ???
  };
};

export const getStructuralBenefitAdapt = (contextState, benefit) => {
  return {
    BeginDate: contextState.coverage,
    EndDate: "",
    Description: benefit["factorId.nameFactor"],
    PortalType: benefitDictionary.getBenefitValue(benefit["factorId.portalType"]), // ???
    CodeFactor: benefit["factorId.factorTypeId.codeFactor"],
    CodeOption: benefitDictionary.getOptionValue(benefit["factorId.portalType"], benefit["codeFactorOption"]),
    DescriptionOption: benefit["description"],
    IdBenefit: benefit["factorId.id"].toString(), // ???
    IdOption: benefit["id"].toString(),
    Factor: benefit["factor"],
    NoCoverage: benefit["isNoCoverageOption"] ? "1" : "0",
    status: "A", // ???
  };
};
